import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

class AssetsDisableForm extends Component {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    disableReason: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ),
    handleValueChange: PropTypes.func,
    isLoading: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    errors: {},
    handleValueChange: () => {},
    isLoading: false,
    isSubmitted: false,
  };

  render = () => (
    <div className="col-12 bbottom mb-3 mt-3">
      <div className="row">
        <div className="col-sm-12">
          <h5>
            <b>{this.props.t('assets.section.disable')}</b>
          </h5>
          <br />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldDate
            error={(this.props.isSubmitted && this.props.errors.disableDate) || {}}
            isLoading={this.props.isLoading}
            name={'disableDate'}
            label={this.props.t('assets.fields.disableDate') + ' * '}
            handleChange={this.props.handleValueChange}
            value={this.props.asset.disableDate}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldSelect
            error={(this.props.isSubmitted && this.props.errors._disableReason) || {}}
            isLoading={this.props.isLoading}
            name={'disableReason'}
            label={this.props.t('assets.fields.disableReason') + ' * '}
            handleChange={this.props.handleValueChange}
            value={this.props.asset._disableReason && this.props.asset._disableReason.id}
          >
            {this.props.disableReason &&
              this.props.disableReason
                .filter((element) => element != null)
                .map(
                  (disableReason) =>
                    disableReason ? (
                      <option value={disableReason.id} key={disableReason.id}>
                        {this.props.t(disableReason.value)}
                      </option>
                    ) : null // For the undefined ones, those values that have been removed from the catalog.
                )}
          </Form.FieldSelect>
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            className="text-right"
            type="number"
            iconLeft="dollar"
            error={(this.props.isSubmitted && this.props.errors.disableAmount) || {}}
            isLoading={this.props.isLoading}
            name={'disableAmount'}
            label={this.props.t('assets.fields.disableAmount') + ' * '}
            handleChange={this.props.handleValueChange}
            value={this.props.asset.disableAmount}
          />
        </div>
        <div className="col-sm-12">
          <Form.FieldTextArea
            error={(this.props.isSubmitted && this.props.errors.disableDetail) || {}}
            isLoading={this.props.isLoading}
            name={'disableDetail'}
            label={this.props.t('assets.fields.disableDetail') + ' * '}
            handleChange={this.props.handleValueChange}
            value={this.props.asset.disableDetail}
          />
        </div>
      </div>
    </div>
  );
}

export default translate()(AssetsDisableForm);



// WEBPACK FOOTER //
// src/components/assets/disable/AssetsDisableForm.js